var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNmr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.666 1.726 4.021 9.589c-.281.18-.87.603-.967.845-.096.242-.04 6.755 0 9.98.001.057 0 .12-.002.19-.008.379-.021.915.306 1.201.387.34 7.64 5.646 11.37 8.347.162.117.3.222.423.314.425.322.655.496.976.528.004.003.007.005.011.005l.051-.001h.05c.005 0 .008-.002.012-.005.321-.032.552-.206.977-.528.122-.092.26-.197.422-.314 3.73-2.701 10.983-8.008 11.37-8.347.327-.286.314-.822.305-1.2a5.388 5.388 0 0 1-.002-.19c.04-3.226.097-9.739 0-9.98-.097-.243-.686-.666-.968-.847L17.71 1.725a3.96 3.96 0 0 1-.347-.26c-.29-.234-.547-.442-1.122-.464L16.24 1a2.734 2.734 0 0 0-.105.002c-.575.022-.831.23-1.122.465-.105.085-.215.174-.347.259z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmr);
export default __webpack_public_path__ + "static/media/NMR.999a6f5d4110ead1b129420f6ced0558.svg";
export { ForwardRef as ReactComponent };